<template>
	<div>
		<v-row justify="center">
			<v-col cols="12">
				<v-card height="100%">
					<v-simple-table>
						<template v-slot:top>
							<v-toolbar flat color="white">
								<v-toolbar-title>Poster Listing</v-toolbar-title>
								<v-divider class="mx-4" inset vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn color="primary" dark class="mb-2" @click="addPoster()">Add</v-btn>
							</v-toolbar>
							<v-toolbar flat>
								<v-autocomplete
									v-model="tagFilter"
									:items="tagList"
									chips
									small-chips
									deletable-chips
									label="Filter by tags"
									multiple
									solo
									dense
									style="max-width: 300px"
									hide-details=""
								></v-autocomplete>
								<div style="display: flex; flex-direction: row; margin-left: 15px">
									<v-btn color="primary" style="margin-right: 10px" @click="filterPosterList">filter</v-btn>
									<v-btn color="primary" @click="resetPosterList">Reset</v-btn>
								</div>
								<v-spacer></v-spacer>
							</v-toolbar>
						</template>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">Poster</th>
									<th class="text-left">Poster Name</th>
									<th class="text-left">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, idxItem) in entityList" :key="idxItem">
									<td>
										{{ item.id }}
										<v-icon @click="up(idxItem)" small>mdi-arrow-up</v-icon>
										<v-icon @click="down(idxItem)" small>mdi-arrow-down</v-icon>
									</td>
									<td>{{ item.name }}</td>

									<td>
										<v-icon @click="editPoster(idxItem)" small class="mr-2" color="blue" title="Poster Settings"
											>mdi-pencil</v-icon
										>
										<v-icon @click="copyLink(item)" small class="mr-2" color="blue" title="Copy Link">mdi-content-copy</v-icon>
										<v-icon
											small
											color="blue"
											@click="
												showDeleteDialog(idxItem, 'POSTER');
												isDeleteBooth = true;
											"
											>mdi-delete</v-icon
										>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
					<v-pagination
						v-model="pagination.page"
						:length="pagination.total"
						:total-visible="pagination.total"
						@input="onPageChange()"
					></v-pagination>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="isAddPoster" persistent max-width="800px">
			<v-card>
				<v-card-title>
					<span class="headline">
						{{ isEdit ? "Edit Poster" : "Add Poster" }}
					</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="isAddPoster = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-col cols="12">
						<v-text-field v-model="entity.name" label="Poster name"></v-text-field>
						<v-combobox
							v-model="entity.tagList"
							:items="tagList"
							label="Select a tag or create a new one"
							multiple
							small-chips
							deletable-chips
							style="margin-bottom: 20px"
						></v-combobox>
						<v-text-field v-model="entity.backgroundColor" label="Background Color" class="ma-0 pa-0">
							<template v-slot:append>
								<v-menu v-model="backgroundColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">mdi-palette</v-icon>
									</template>
									<v-card>
										<v-card-text class="pa-0">
											<v-color-picker v-model="entity.backgroundColor" flat />
										</v-card-text>
									</v-card>
								</v-menu>
							</template>
						</v-text-field>
						<br />
						<div
							style="border: 1px solid black; margin: 10px; width: 653px; margin: auto"
							:style="{ backgroundColor: entity.backgroundColor }"
						>
							<v-row v-for="(item, index) in entity.posterDataList" :key="index" style="margin: 5px; padding: 0px">
								<v-col v-for="(item1, index1) in item" :key="index1" :cols="10 / item.length" style="padding: 1px">
									<v-btn
										v-if="item1.type == 'URL FIELD'"
										width="100%"
										:color="item1.backgroundColor"
										:style="{ color: item1.fontColor }"
										@click="showDialogInputURL(item, index1)"
									>
										{{ item1.label }}
									</v-btn>
									<v-btn
										v-else-if="item1.type == 'FILE DOWNLOAD'"
										width="100%"
										:color="item1.backgroundColor"
										:style="{ color: item1.fontColor }"
										@click="showDialogInputFileDownload(item, index1)"
									>
										{{ item1.label }}
										<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
									</v-btn>
									<div
										v-else-if="item1.type == 'TEXT'"
										v-html="item1.value"
										style="border: 1px solid black; padding: 10px 10px 0px 10px"
										:style="{ backgroundColor: item1.backgroundColor }"
										@click="showDialogInputText(item, index1)"
									></div>
									<v-carousel v-else-if="item1.type == 'GALLERY'" hide-delimiters height="368" style="border: 1px solid black">
										<v-carousel-item
											v-for="(image, idxImage) in item1.images"
											class="galley_poster"
											:key="idxImage"
											:src="!image || image.includes('add-image.png') ? image : $root.asset(image)"
											reverse-transition="fade"
											transition="fade"
											@click="showDialogInputGallery(item, index1, idxImage, item1.images.length - 1)"
										>
											<v-btn
												v-if="idxImage != item1.images.length - 1"
												class="ma-2"
												color="error"
												fab
												small
												@click="item1.images.splice(idxImage, 1)"
											>
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</v-carousel-item>
									</v-carousel>
									<iframe
										v-else-if="item1.type == 'VIDEO'"
										id="video_poster"
										:src="$root.asset(item1.value)"
										frameborder="0"
										allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
										scrolling="0"
										width="100%"
										style="border: 1px solid black"
										height="300px"
									>
									</iframe>
									<v-btn
										v-if="item1.type == 'VIDEO'"
										class="ma-2"
										color="green"
										dark
										fab
										x-small
										@click="showDialogInputVideo(item, index1)"
										:style="{
											position: 'absolute',
											transform: 'translateX(' + -526 / item.length + 'px)'
										}"
									>
										<v-icon>mdi-pencil</v-icon>
									</v-btn>
								</v-col>

								<v-col cols="1"></v-col>
								<v-col cols="1" style="padding: 0px">
									<v-speed-dial :direction="direction" :open-on-hover="hover" :transition="transition">
										<template v-slot:activator>
											<v-app-bar-nav-icon style="background-color: white"></v-app-bar-nav-icon>
										</template>
										<v-btn fab dark x-small color="green" @click="editRow(item)">
											<v-icon>mdi-pencil</v-icon>
										</v-btn>
										<v-btn fab dark x-small color="red" @click="showDeleteDialog(index, 'ROW')">
											<v-icon>mdi-delete</v-icon>
										</v-btn>
									</v-speed-dial>
								</v-col>
							</v-row>
							<v-row style="margin: 5px; border: 1px solid black">
								<v-col cols="12">
									<v-btn width="100%" color="blue" @click="addRow">ADD ROW</v-btn>
								</v-col>
							</v-row>
						</div>
						<br />
						<div class="d-flex justify-end">
							<v-btn color="blue darken-1" text @click="preview">Preview</v-btn>
							<v-btn color="blue darken-1" text @click="closeFormPoster">Cancel</v-btn>
							<v-btn color="blue darken-1" text @click="save()">Save</v-btn>
						</div>
					</v-col>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isAddRow" max-width="750px">
			<v-card>
				<v-card-text>
					<br />
					<div style="border: 1px solid black; width: 700px; margin: auto">
						<div style="border: 1px solid black; margin: 10px">
							<v-row>
								<v-col cols="12">
									<v-row style="margin: 5px">
										<v-col cols="4">
											<v-combobox v-model="fieldType1" :items="fieldTypeList" outlined hide-details="true" dense></v-combobox>
										</v-col>
										<v-col cols="1">
											<v-btn color="blue" @click="chooseField(1)">Add 1 column row</v-btn>
										</v-col>
										<v-col cols="7"></v-col>

										<v-col cols="12" class="text-center">
											<span>OR</span>
										</v-col>

										<v-col cols="4">
											<v-combobox v-model="fieldType2" :items="fieldTypeList" outlined hide-details="true" dense></v-combobox>
										</v-col>
										<v-col cols="4">
											<v-combobox v-model="fieldType3" :items="fieldTypeList" outlined hide-details="true" dense></v-combobox>
										</v-col>
										<v-col cols="1">
											<v-btn color="blue" @click="chooseField(2)">Add 2 column row</v-btn>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDelete" max-width="500px">
			<v-card>
				<v-card-title>Delete</v-card-title>
				<v-card-text>Are you sure you want to delete?</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
					<v-btn color="primary" text @click="deleteRow">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isDialogInputURL" max-width="500px" persistent>
			<v-card>
				<v-card-title>URL FIELD</v-card-title>
				<v-card-text>
					<v-text-field v-model="entityUrl.value" label="URL"></v-text-field>
					<v-text-field v-model="entityUrl.label" label="Label"></v-text-field>
					<v-text-field v-model="entityUrl.backgroundColor" label="Background Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="urlBackgroundColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityUrl.backgroundColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>
					<v-text-field v-model="entityUrl.fontColor" label="Font Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="urlFontColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityUrl.fontColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>
					<div class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							@click="
								isDialogInputURL = false;
								editTmpRow = [];
								tmpIndexCol = -1;
							"
							>Cancel</v-btn
						>
						<v-btn color="primary" text @click="addUrl">ADD</v-btn>
					</div>
				</v-card-text>
				<v-card-actions> </v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isDialodInputFileDownload" max-width="500px" persistent>
			<v-card>
				<v-card-title>FILE DOWNLOAD</v-card-title>
				<v-card-text>
					<input ref="attachment1" type="file" @change="onBackgroundUpload" style="display: none" />
					<v-text-field
						v-model="fileName"
						placeholder="Upload File"
						prepend-icon="mdi-file"
						@click="openFileDialog()"
						readonly
					></v-text-field>
					<v-text-field v-model="entityFileDownload.label" label="Label"></v-text-field>
					<v-text-field v-model="entityFileDownload.backgroundColor" label="Background Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="fileDownloadBackgroundColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityFileDownload.backgroundColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>
					<v-text-field v-model="entityFileDownload.fontColor" label="Font Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="fileDownloadFontColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityFileDownload.fontColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>
					<v-text-field v-model="entityFileDownload.iconColor" label="Icon Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="fileDownloadIconColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityFileDownload.iconColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>
					<div class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							@click="
								isDialodInputFileDownload = false;
								editTmpRow = [];
								tmpIndexCol = -1;
								fileName = '';
							"
							>Cancel</v-btn
						>
						<v-btn color="primary" text @click="addFileDownload">ADD</v-btn>
					</div>
				</v-card-text>
				<v-card-actions> </v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- eager and v-if isDialodInputText for card to prevent blank tinyMCE editor -->
		<v-dialog v-model="isDialodInputText" max-width="500px" persistent eager>
			<v-card v-if="isDialodInputText">
				<v-card-title>TEXT</v-card-title>
				<v-card-text>
					<editor
						class="text_poster"
						api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67"
						:init="initTextEditor"
						v-model="entityText.value"
						style="background-color: #eee"
					/>
					<br />
					<v-text-field v-model="entityText.backgroundColor" label="Background Color" class="ma-0 pa-0">
						<template v-slot:append>
							<v-menu v-model="textBackgroundColorPicker" top nudge-bottom="40" nudge-left="16" :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">mdi-palette</v-icon>
								</template>
								<v-card>
									<v-card-text class="pa-0">
										<v-color-picker v-model="entityText.backgroundColor" flat />
									</v-card-text>
								</v-card>
							</v-menu>
						</template>
					</v-text-field>

					<div class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							@click="
								isDialodInputText = false;
								editTmpRow = [];
								tmpIndexCol = -1;
							"
							>Cancel</v-btn
						>
						<v-btn color="primary" text @click="addText">ADD</v-btn>
					</div>
				</v-card-text>
				<v-card-actions> </v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isDialodInputGallery" max-width="500px" persistent>
			<v-card>
				<v-card-title>GALLERY</v-card-title>
				<v-card-text>
					<v-file-input
						v-model="attachments"
						accept="image/png, image/jpeg, image/jpg"
						multiple
						show-size
						label="Choose image files"
					></v-file-input>
					<br />
					<div class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							@click="
								isDialodInputGallery = false;
								editTmpRow = [];
								tmpIndexCol = -1;
								attachments = null;
							"
							>Cancel</v-btn
						>
						<v-btn color="primary" text @click="addGallery">ADD</v-btn>
					</div>
				</v-card-text>
				<v-card-actions> </v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isDialodInputVideo" max-width="500px" persistent>
			<v-card>
				<v-card-title>VIDEO</v-card-title>
				<v-card-text>
					<v-select v-model="entityVideo.videoType" :items="['Upload', 'URL']" :label="entityVideo.videoType" v-show="false"></v-select>
					<input type="file" ref="attachment2" id="file-video" accept="video/mp4" style="display: none" @change="previewVideo" required />
					<v-text-field
						class="mb-2"
						v-if="entityVideo.videoType === 'Upload'"
						v-model="entityVideo.value"
						:label="entityVideo.videoType"
						hint="it's recommended to use video with resolution of 1080 pixels."
						placeholder="Upload"
						@click="$refs.attachment2.click()"
					></v-text-field>
					<v-text-field
						v-else
						v-model="entityVideo.value"
						:label="entityVideo.videoType"
						@change="entityVideo.value = $root.parseVideoUrl(entityVideo.value)"
						hint="URL (Vimeo/YouTube)"
						placeholder="URL"
					></v-text-field>
					<br />
					<div class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							@click="
								isDialodInputVideo = false;
								editTmpRow = [];
								tmpIndexCol = -1;
								attachments = null;
							"
							>Cancel</v-btn
						>
						<v-btn color="primary" text @click="addVideo">ADD</v-btn>
					</div>
				</v-card-text>
				<v-card-actions> </v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="isPreview" max-width="625px">
			<v-card style="background-color: #000000bb">
				<v-card-title class="justify-center">
					<span class="headline" style="color: white">{{ entityPreview.name }}</span>
				</v-card-title>

				<v-card-text>
					<div
						style="margin: 10px; width: 555px; margin: auto; border-top-left-radius: 12px; border-top-right-radius: 12px; padding: 5px"
						:style="{ backgroundColor: entityPreview.backgroundColor }"
					>
						<v-row v-for="(item, index) in entityPreview.posterDataList" :key="index" style="margin: 5px; padding: 0px">
							<v-col v-for="(item1, index1) in item" :key="index1" :cols="12 / item.length" style="padding: 1px">
								<v-btn
									v-if="item1.type == 'URL FIELD'"
									width="100%"
									:color="item1.backgroundColor"
									:style="{ color: item1.fontColor }"
									@click="openNewTab(item1.value)"
								>
									{{ item1.label }}
								</v-btn>
								<v-btn
									v-else-if="item1.type == 'FILE DOWNLOAD'"
									width="100%"
									:color="item1.backgroundColor"
									:style="{ color: item1.fontColor }"
									@click="download(item1.value)"
								>
									{{ item1.label }}
									<v-icon :color="item1.iconColor" medium>mdi-download</v-icon>
								</v-btn>
								<div
									v-else-if="item1.type == 'TEXT'"
									v-html="item1.value"
									:style="{
										backgroundColor: item1.backgroundColor,
										border: '1px solid ' + item1.backgroundColor
									}"
									style="border: 1px solid black; padding: 10px 10px 0px 10px"
								></div>
								<v-carousel v-else-if="item1.type == 'GALLERY'" hide-delimiters height="368">
									<v-carousel-item
										v-for="(image, idxImage) in item1.images"
										class="galley_poster"
										:key="idxImage"
										:src="$root.asset(image)"
										reverse-transition="fade"
										transition="fade"
										@click="showDialogCarousel(item1.images, idxImage)"
									>
									</v-carousel-item>
								</v-carousel>
								<iframe
									v-else-if="item1.type == 'VIDEO'"
									id="video_poster"
									:src="$root.asset(item1.value)"
									frameborder="0"
									allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
									scrolling="0"
									width="100%"
									height="300px"
								>
								</iframe>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCarousel.show" no-click-animation persistent content-class="col-12 hide-box-shadow" fullscreen>
			<v-card>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogCarousel.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-carousel v-model="dialogCarousel.open" hide-delimiters class="custom-slider" height="89vh">
						<v-carousel-item
							class="text-center"
							v-for="(item, index) in dialogCarousel.images"
							:key="index"
							reverse-transition="fade"
							transition="fade"
						>
							<div
								v-if="!item.endsWith('.pdf')"
								:style="{
									backgroundImage: 'url(' + $root.asset(item).replace(/\\/g, '/').replace(/ /g, '%20') + ')',
									backgroundRepeat: 'no-repeat',
									backgroundSize: 'contain !important',
									backgroundPosition: 'center',
									height: '100%',
									width: '100%'
								}"
							></div>
							<iframe
								v-else
								frameborder="0"
								allow="autoplay; encrypted-media"
								scrolling="0"
								width="100%"
								class="iframe-size"
								:src="$root.asset(item)"
								allowfullscreen
								style="height: 100%"
							></iframe>
						</v-carousel-item>
					</v-carousel>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar">
			{{ snackbarContent }}
			<template v-slot:action="{ attrs }">
				<v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>


<style>
.galley_poster > div > .v-image__image--cover {
	background-size: cover;
}
</style>

<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["experienceId"],
	components: {
		editor: Editor
	},
	data: () => ({
		baseLocation: axios.defaults.baseURL,
		pagination: {
			page: 1,
			total: 0,
			perPage: 5,
			visible: 3
		},
		tagList: [],
		fieldTypeList: ["URL FIELD", "FILE DOWNLOAD", "TEXT", "GALLERY", "VIDEO"],
		fieldType1: "URL FIELD",
		fieldType2: "URL FIELD",
		fieldType3: "URL FIELD",
		isAddPoster: false,
		boothList: [],
		entityList: null,
		entity: {
			backgroundColor: "#e0dede",
			posterDataList: []
		},
		entityPreview: {
			backgroundColor: "#e0dede",
			posterDataList: []
		},
		attachments: null,
		attachment1: null,
		attachment2: null,
		backgroundColorPicker: false,
		fileName: "",
		editTmpRow: [],
		tmpIndexCol: -1,
		direction: "left",
		hover: false,
		transition: "slide-y-reverse-transition",
		isShowForm: false,
		isAddRow: false,
		indexDeleteData: -1,
		dialogDelete: false,
		isDialogInputURL: false,
		entityUrl: { value: "", label: "" },
		urlBackgroundColorPicker: false,
		urlFontColorPicker: false,
		isDialodInputFileDownload: false,
		entityFileDownload: { value: "", label: "" },
		fileDownloadBackgroundColorPicker: false,
		fileDownloadFontColorPicker: false,
		fileDownloadIconColorPicker: false,
		isDialodInputText: false,
		entityText: { value: "", label: "" },
		textBackgroundColorPicker: false,
		isDialodInputGallery: false,
		entityGellary: { value: "", label: "" },
		isDialodInputVideo: false,
		entityVideo: { value: "", label: "", type: "", videoType: "Upload" },
		videoType: "Upload",
		initTextEditor: {
			height: 300,
			menubar: false,
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table paste code help wordcount"
			],
			toolbar1: "undo redo | formatselect",
			toolbar2: "fontselect | fontsizeselect",
			toolbar3: "alignleft aligncenter alignright | bold italic underline | forecolor backcolor | link",
			fontsize_formats: '1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt'
		},
		isPreview: false,
		dialogCarousel: { show: false, images: [] },
		isPoster: false,
		isEdit: false,
		allPosterList: [],
		snackbar: false,
		snackbarContent: null,
		origin: null,
		tagFilter: []
	}),
	mounted() {
		this.listPoster();
		this.listTagPoster();
		this.origin = this.$window.location.origin;

		this.$root.appendTinyMCECustomFonts(this.initTextEditor);
	},

	methods: {
		listPoster() {
			axios.get("/system/poster/find?&experienceId=" + this.experienceId).then((response) => {
				this.entityList = response.data;
				this.allPosterList = this.$root.clone(this.entityList);
			});
		},
		listTagPoster() {
			axios.get("/system/poster/tag/list?&experienceId=" + this.experienceId).then((response) => {
				this.tagList = response.data;
			});
		},
		addPoster() {
			this.entity = {
				backgroundColor: "#e0dede",
				posterDataList: []
			};
			this.isEdit = false;
			this.isAddPoster = true;
		},
		editPoster(index) {
			this.entity = this.$root.clone(this.entityList[index]);
			this.isAddPoster = true;
			this.isEdit = true;
		},
		closeFormPoster() {
			this.isAddPoster = false;
		},
		addRow() {
			this.editTmpRow = [];
			this.isAddRow = true;
		},
		editRow(row) {
			this.isAddRow = true;
			if (row.length == 1) {
				this.fieldType1 = row[0].type;
			} else {
				this.fieldType2 = row[0].type;
				this.fieldType3 = row[1].type;
			}
			this.editTmpRow = row;
		},
		chooseField(sumCol) {
			let row = [];
			if (sumCol == 1) {
				row = [
					{
						type: this.fieldType1,
						value: this.getValue(this.fieldType1),
						label: this.getLabel(this.fieldType1),
						images: this.getImages(this.fieldType1),
						backgroundColor: this.getBackgroundColor(this.fieldType1),
						fontColor: this.getFontColor(this.fieldType1),
						iconColor: this.getIconColor(this.fieldType1)
					}
				];
			} else {
				row = [
					{
						type: this.fieldType2,
						value: this.getValue(this.fieldType2),
						label: this.getLabel(this.fieldType2),
						images: this.getImages(this.fieldType2),
						backgroundColor: this.getBackgroundColor(this.fieldType2),
						fontColor: this.getFontColor(this.fieldType2),
						iconColor: this.getIconColor(this.fieldType2)
					},
					{
						type: this.fieldType3,
						value: this.getValue(this.fieldType3),
						label: this.getLabel(this.fieldType3),
						images: this.getImages(this.fieldType3),
						backgroundColor: this.getBackgroundColor(this.fieldType3),
						fontColor: this.getFontColor(this.fieldType3),
						iconColor: this.getIconColor(this.fieldType3)
					}
				];
			}

			if (this.editTmpRow.length == 0) {
				this.entity.posterDataList.push(row);
			} else {
				let index = this.entity.posterDataList.indexOf(this.editTmpRow);
				this.entity.posterDataList.splice(index, 1);
				this.entity.posterDataList.splice(index, 0, row);
				this.editTmpRow = [];
			}
			this.isAddRow = false;
		},
		getValue(fieldType) {
			if (fieldType === "TEXT") {
				return "<p style='text-align: center;'><span style=\"color: #ecf0f1;\"><strong>TEXT</strong></span></p>";
			} else {
				return "";
			}
		},
		getLabel(fieldType) {
			if (fieldType === "URL FIELD") {
				return "URL FIELD";
			} else if (fieldType === "FILE DOWNLOAD") {
				return "FILE DOWNLOAD";
			} else if (fieldType === "VIDEO") {
				return "<p style='text-align: center;'><strong>VIDEO</strong></p>";
			} else {
				return "";
			}
		},
		getBackgroundColor(fieldType) {
			if (fieldType === "URL FIELD") {
				return "#f3f5f7";
			} else if (fieldType === "FILE DOWNLOAD") {
				return "#f3f5f7";
			} else if (fieldType === "TEXT") {
				return "#8d77f1";
			} else {
				return "";
			}
		},
		getFontColor(fieldType) {
			if (fieldType === "URL FIELD") {
				return "#8d77f1";
			} else if (fieldType === "FILE DOWNLOAD") {
				return "#8d77f1";
			} else {
				return "";
			}
		},
		getIconColor(fieldType) {
			if (fieldType === "FILE DOWNLOAD") {
				return "#F44336";
			} else {
				return "";
			}
		},
		getImages(fieldType) {
			if (fieldType === "GALLERY") {
				return [this.baseLocation + "\\resource\\image\\poster\\add-image.png"];
			} else {
				return null;
			}
		},
		showDeleteDialog(index, type) {
			if (type === "POSTER") {
				this.isPoster = true;
			}
			this.indexDeleteData = index;
			this.dialogDelete = true;
		},
		deleteRow() {
			if (this.isPoster) {
				this.remove();
			} else {
				this.entity.posterDataList.splice(this.indexDeleteData, 1);
				this.dialogDelete = false;
				this.indexDeleteData = -1;
			}
		},
		showDialogInputURL(item, indexCol) {
			this.isDialogInputURL = true;
			this.entityUrl.value = item[indexCol].value;
			this.entityUrl.label = item[indexCol].label;
			this.entityUrl.backgroundColor = item[indexCol].backgroundColor;
			this.entityUrl.fontColor = item[indexCol].fontColor;
			this.editTmpRow = item;
			this.tmpIndexCol = indexCol;
		},
		addUrl() {
			let index = this.entity.posterDataList.indexOf(this.editTmpRow);
			this.entity.posterDataList[index][this.tmpIndexCol].value = this.entityUrl.value;
			this.entity.posterDataList[index][this.tmpIndexCol].label = this.entityUrl.label;
			this.entity.posterDataList[index][this.tmpIndexCol].backgroundColor = this.entityUrl.backgroundColor;
			this.entity.posterDataList[index][this.tmpIndexCol].fontColor = this.entityUrl.fontColor;
			this.editTmpRow = [];
			this.tmpIndexCol = -1;
			this.isDialogInputURL = false;
		},
		showDialogInputFileDownload(item, indexCol) {
			this.fileName = item[indexCol].value;
			this.isDialodInputFileDownload = true;
			this.entityFileDownload.value = item[indexCol].value;
			this.entityFileDownload.label = item[indexCol].label;
			this.entityFileDownload.backgroundColor = item[indexCol].backgroundColor;
			this.entityFileDownload.fontColor = item[indexCol].fontColor;
			this.entityFileDownload.iconColor = item[indexCol].iconColor;
			this.entityFileDownload.attachment = item[indexCol].attachment;
			this.editTmpRow = item;
			this.tmpIndexCol = indexCol;
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entityFileDownload.value = fr.result;
					this.entityFileDownload.attachment = files[0]; // this is an image file that can be sent to server...
				});
				this.fileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
			} else {
				this.entityFileDownload.attachment = null;
			}
		},
		openFileDialog() {
			this.$refs.attachment1.click();
		},
		async addFileDownload() {
			let index = this.entity.posterDataList.indexOf(this.editTmpRow);

			if (this.entityFileDownload.attachment) {
				let formData = new FormData();
				formData.append("attachment1", this.entityFileDownload.attachment);
				formData.append("experienceId", this.experienceId);
				await axios.post("/system/poster/upload/file", formData).then((response) => {
					this.entity.posterDataList[index][this.tmpIndexCol].value = response.data;
				});
			}

			this.entity.posterDataList[index][this.tmpIndexCol].label = this.entityFileDownload.label;
			this.entity.posterDataList[index][this.tmpIndexCol].backgroundColor = this.entityFileDownload.backgroundColor;
			this.entity.posterDataList[index][this.tmpIndexCol].fontColor = this.entityFileDownload.fontColor;
			this.entity.posterDataList[index][this.tmpIndexCol].iconColor = this.entityFileDownload.iconColor;
			this.entity.posterDataList[index][this.tmpIndexCol].attachment = this.entityFileDownload.attachment;

			this.editTmpRow = [];
			this.tmpIndexCol = -1;
			this.isDialodInputFileDownload = false;
		},
		showDialogInputText(item, indexCol) {
			this.isDialodInputText = true;
			this.entityText.value = item[indexCol].value;
			this.entityText.backgroundColor = item[indexCol].backgroundColor;
			this.editTmpRow = item;
			this.tmpIndexCol = indexCol;
		},
		addText() {
			let index = this.entity.posterDataList.indexOf(this.editTmpRow);
			this.entity.posterDataList[index][this.tmpIndexCol].value = this.entityText.value;
			this.entity.posterDataList[index][this.tmpIndexCol].backgroundColor = this.entityText.backgroundColor;
			this.editTmpRow = [];
			this.tmpIndexCol = -1;
			this.isDialodInputText = false;
		},
		showDialogInputGallery(item, indexCol, indexImage, indexLastImage) {
			if (indexImage == indexLastImage) {
				this.isDialodInputGallery = true;
				this.editTmpRow = item;
				this.tmpIndexCol = indexCol;
			}
		},
		async addGallery() {
			let index = this.entity.posterDataList.indexOf(this.editTmpRow);
			let length = this.entity.posterDataList[index][this.tmpIndexCol].images.length;
			let addImage = this.entity.posterDataList[index][this.tmpIndexCol].images[length - 1];
			this.entity.posterDataList[index][this.tmpIndexCol].images.splice(length - 1, 1);

			for (let i = 0; i < this.attachments.length; i++) {
				let formData = new FormData();
				formData.append("attachment1", this.attachments[i]);
				formData.append("experienceId", this.experienceId);
				await axios.post("/system/poster/upload/image", formData).then((response) => {
					this.entity.posterDataList[index][this.tmpIndexCol].images.push(response.data);
				});
			}
			this.entity.posterDataList[index][this.tmpIndexCol].images.push(addImage);
			this.attachments = null;
			this.editTmpRow = [];
			this.tmpIndexCol = -1;
			this.isDialodInputGallery = false;
		},
		showDialogInputVideo(item, indexCol) {
			this.isDialodInputVideo = true;
			this.entityVideo.value = item[indexCol].value;
			this.entityVideo.videoType = item[indexCol].videoType ? item[indexCol].videoType : "URL";
			this.editTmpRow = item;
			this.tmpIndexCol = indexCol;
		},
		async addVideo() {
			let index = this.entity.posterDataList.indexOf(this.editTmpRow);

			if (this.entityVideo.videoType === "Upload") {
				let formData = new FormData();
				formData.append("attachment1", this.attachment2);
				formData.append("experienceId", this.experienceId);
				await axios.post("/system/poster/upload/file", formData).then((response) => {
					this.entity.posterDataList[index][this.tmpIndexCol].value = response.data;
				});
			} else {
				this.entity.posterDataList[index][this.tmpIndexCol].value = this.entityVideo.value;
			}
			this.entity.posterDataList[index][this.tmpIndexCol].videoType = this.entityVideo.videoType;
			this.editTmpRow = [];
			this.tmpIndexCol = -1;
			this.isDialodInputVideo = false;
		},
		previewVideo(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let videoName = files[0].name;
				if (videoName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entityVideo.previewVideo = URL.createObjectURL(files[0]);
					this.entityVideo.value = videoName;
					this.attachment2 = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.attachment2 = null;
			}
		},
		preview() {
			this.isPreview = true;
			this.entityPreview = this.$root.clone(this.entity);
			for (let item of this.entityPreview.posterDataList) {
				for (let item1 of item) {
					if (item1.type === "GALLERY") {
						let length = item1.images.length;
						item1.images.splice(length - 1, 1);
					}
				}
			}
		},
		openNewTab(url) {
			window.open(url, "blank");
		},
		download(name) {
			location.href = this.baseLocation + "/asset/file/" + name + "?download&time=" + new Date();
		},
		showDialogCarousel(value, index) {
			this.dialogCarousel.show = true;
			this.dialogCarousel.open = index;
			this.dialogCarousel.images = value;
		},
		save() {
			let url = this.isEdit ? "/system/poster/edit" : "/system/poster/add";
			axios
				.post(url, {
					poster: this.entity,
					experienceId: this.experienceId
				})
				.then(() => {
					this.listPoster();
					this.listTagPoster();
					this.closeFormPoster();
				});
		},
		remove() {
			axios
				.post("/system/poster/delete", { id: this.entityList[this.indexDeleteData].id })
				.then(() => {
					this.listPoster();
					this.listTagPoster();
					this.dialogDelete = false;
					this.indexDeleteData = -1;
				})
				.catch(() => {});
		},
		up(index) {
			if (index > 0) {
				this.swapLine(index - 1, index);
			}
		},
		down(index) {
			if (index + 1 < this.entityList.length) {
				this.swapLine(index, index + 1);
			}
		},
		swapLine(a, b) {
			axios
				.post("/system/poster/swap", {
					entity1: this.entityList[a],
					entity2: this.entityList[b]
				})
				.then(() => {
					this.listPoster();
				});
		},
		filterPosterList() {
			axios
				.post("/system/poster/filter", {
					tagFilter: this.tagFilter,
					experienceId: this.experienceId
				})
				.then((response) => {
					this.entityList = response.data;
				});
		},
		resetPosterList() {
			this.tagFilter = [];
			this.entityList = this.allPosterList;
		},
		copyLink(item) {
			this.$clipboard(
				this.origin + "/#/poster/setup/" + this.experienceId + "/" + this.$store.state.principal.tenantId + "/" + item.dataMap.posterSetupId
			);
			this.snackbar = true;
			this.snackbarContent = "Copied";
		}
	}
};
</script>